export default function FrontFooter() {
  return (
    <>
      <div className="text-center text-white bg-gray-600 p-2">長庚護心</div>
    </>
  );
}
